<template>
  <div class="table--wrapper no-break-inside mt-3 mb-4" :class="{ 'overflow': overflow }">
    
    <table 
      class="table has-smallest-font"
      :class="{ 'overflow': overflow, 'is-fullwidth': !overflow, 'mb-3': hasFootnotes }">

      <thead>
        <tr class="has-text-centered">
          <th
            v-for="(header, i) in headers"
            :key="i"
            :class="header.class">
            <div v-html="header.label"></div>
          </th>
        </tr>
      </thead>

      <tbody>
        <template v-for="(row, i) in processedSummary">
          <tr
            class="v-centered has-text-right"
            :key="i">
            <td class="capitalize price--summary has-text-left">
              <div 
                class="flex flex--row flex--align-center flex--justify-start">
                <img
                  v-if="row.icon"
                  :src="row.icon" 
                  class="exception pricing-summary-icon"/>
                <div v-html="processRowLabel(row.pricing_summary)">
                </div>
              </div>
            </td>
            <td class="price--area">
              {{ row.measure | commasep(0, true) }} {{ row.unit | uppercase }}
            </td>
            <td class="price--value">
              {{ row.what_should_be_paid | commasep(0, true) }}
            </td>
            <td class="price--savings">
              {{ row.price - row.what_should_be_paid | commasep(0, true) }}
            </td>
            <td class="price--quote">
              {{ row.price | commasep(0, true) }}
            </td>
            <td class="price--system-size">
              {{ row.system_size | commasep(0, true) }}
            </td>
            <td class="price--energy-revenue">
              {{ row.elec_proceeds_for_business | commasep(0, true) }}
            </td>
            <!-- <td>
              {{ row.price - row.elec_proceeds_for_business | round(0) }}
            </td> -->
          </tr>
        </template>
      </tbody>

      <tfoot>
        <tr
          class="v-centered has-text-right has-text-weight-bold">
          <td colspan=2 class="price--summary">
            Total before HST
          </td>
          <td class="price--value">
            {{ getTotal('what_should_be_paid') | commasep(0, true) }}
          </td>
          <td class="price--savings">
            {{ getTotal('what_should_be_paid', 'price') | commasep(0, true) }}
          </td>
          <td class="price--quote">
            {{ getTotal('price') | commasep(0, true) }}
          </td>
          <td class="price--system-size">
            <!-- {{ getTotal('system_size') | commasep(0, true) }} -->
          </td>
          <td class="price--energy-revenue">
            {{ getTotal('elec_proceeds_for_business') | commasep(0, true) }}
          </td>
          <!-- <td class="price--net">
            {{ getTotal('price', 'elec_proceeds_for_business') | currency(0) }}
          </td> -->
        </tr>
        <tr
          class="v-centered has-text-right has-text-weight-bold">
          <td colspan=2 class="price--summary">
            HST
          </td>
          <td class="price--value">
            <!-- {{ getTotal('what_should_be_paid') * 0.13 | commasep(0, true) }} -->
          </td>
          <td class="price--savings">
            <!-- {{ getTotal('what_should_be_paid', 'price') * 0.13 | commasep(0, true) }} -->
          </td>
          <td class="price--quote">
            {{ getTotal('price') * 0.13 | commasep(0, true) }}
          </td>
          <td class="price--system-size">
          </td>
          <td class="price--energy-revenue">
            <!-- {{ getTotal('elec_proceeds_for_business') * 0.13 | commasep(0, true) }} -->
          </td>
          <!-- <td class="price--net">
            {{ getTotal('price', 'elec_proceeds_for_business') * 0.13 | currency(0) }}
          </td> -->
        </tr>
        <tr
          class="v-centered has-text-right has-text-weight-bold">
          <td colspan=2 class="price--summary">
            Total including HST
          </td>
          <td class="price--value">
            <!-- {{ getTotal('what_should_be_paid') * 1.13 | commasep(0, true) }} -->
          </td>
          <td class="price--savings">
            <!-- {{ getTotal('what_should_be_paid', 'price') * 1.13 | commasep(0, true) }} -->
          </td>
          <td class="price--quote">
            {{ getTotal('price') * 1.13 | commasep(0, true) }}
          </td>
          <td class="price--system-size">
          </td>
          <td class="price--energy-revenue">
            <!-- {{ getTotal('elec_proceeds_for_business') * 1.13 | commasep(0, true) }} -->
          </td>
          <!-- <td class="price--net">
            {{ getTotal('price', 'elec_proceeds_for_business') * 1.13 | currency(0) }}
          </td> -->
        </tr>

        <tr class="has-text-weight-bold top-spacer">
          <td class="price--energy-revenue" colspan=5>
            <div>
              Packaging and Delivery
            </div>
          </td>
          <td class="has-text-right price--energy-revenue">
            {{ runs }}
          </td>
          <td class="has-text-right price--energy-revenue">
            Runs
          </td>
        </tr>

        <tr class="has-text-weight-bold">
          <td class="price--energy-revenue" colspan=5>
            <div>
              Installation and Maintenance
              <span v-if="hasFootnotes" class="has-text-weight-normal">[2]</span>
            </div>
          </td>
          <td class="has-text-right price--energy-revenue">
            Included
          </td>
          <td class="has-text-right price--energy-revenue">
            Crew
          </td>
        </tr>
      </tfoot>
    </table>

    <div v-if="hasFootnotes" class="help">
      <div>
        [1] Area is including material waste.
      </div>
      <div>
        [2] Maintenance is included for the period of the energy contract.
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    estimation: {
      type: Object
    },
    railingType: {
      type: String,
      default: '1100 1400'
    },
    pricingType: {
      type: String,
      default: 'mpa'
    },
    overflow: {
      type: Boolean,
      default: true
    },
    hasFootnotes: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      solarCladdingIcon: 'https://camas.app/resources/static/images/images/image__9c328440f31f6d1690d1d249c8abade8.png',
      claddingIcon: 'https://camas.app/resources/static/images/images/image__7029a2ffe555cf5cd650c49bb41e7b96.png',
      solarRailingIcon: 'https://camas.app/resources/static/images/images/image__0849e23f92d20ba35c78f55f335344f4.png',
      batteryIcon: 'https://camas.app/resources/static/images/images/image__ebb819c76fbeddcea4604cf9afeafcc2.png',
      irregularCladdingIcon: 'https://camas.app/resources/static/images/images/image__2aafde591fadd82dec8f54e3b63beda6.png',
      irregularSolarIcon: 'https://camas.app/resources/static/images/images/image__520ab8a3ad6d350a8df7c5c0c94d85e6.png'
    }
  },
  computed: {
    runs({ estimation }) {
      if (estimation.no_of_runs > 0) {
        return estimation.no_of_runs
      } else {
        return 'Included'
      }
    },
    headers({pricingType}) {
      if (pricingType == 'mpa') {
        return [
          { label: '', class: 'price--summary' },
          { label: 'AREA [1]', class: 'price--area' },
          { label: 'REGULAR <span class="text--nowrap">COST ($)</span>', class: 'price--value' },
          { label: 'MPA <span class="text--nowrap">SAVINGS ($)</span>', class: 'price--savings' },
          { label: 'MPA <span class="text--nowrap">QUOTE ($)</span>', class: 'price--quote'  },
          { label: 'SYSTEM <span class="text--nowrap">SIZE (kW)</span>', class: 'price--system-size' },
          { label: `<span class="is-size-7">APPROX.</span><br/>ENERGY 
                    <span class="text--nowrap">REVENUE ($)</span>
                    <div class="is-size-7 has-text-weight-normal">over 30 yrs</div>`, 
            class: 'price--energy-revenue' }
        ]
      } else {
        return [
          { label: '', class: 'price--summary' },
          { label: 'AREA [1]', class: 'price--area' },
          { label: 'REGULAR <span class="text--nowrap">COST ($)</span>', class: 'price--value' },
          { label: 'DPA <span class="text--nowrap">INVESTMENT ($)</span>', class: 'price--savings' },
          { label: 'DPA <span class="text--nowrap">QUOTE ($)</span>', class: 'price--quote'  },
          { label: 'SYSTEM <span class="text--nowrap">SIZE (kW)</span>', class: 'price--system-size' },
          { label: `<span class="is-size-7">APPROX.</span><br/>ENERGY 
                    <span class="text--nowrap">REVENUE ($)</span> 
                    <div class="is-size-7 has-text-weight-normal">over 30 yrs</div>`, 
            class: 'price--energy-revenue' }
        ]
      }
    },
    summaryObject({ estimation, pricingType }) {
      let summaryName = pricingType == 'dpa' ? 'estimation_summary_dpa' : 'estimation_summary';
      return estimation[summaryName];
    },
    irregularCladding({ summaryObject, irregularCladdingIcon }) {
      let irregularCladding = summaryObject.irregular_price_by_material.filter(
        d => d.product_brand == 'Cladify'
      )
      
      return irregularCladding.length > 0 ? irregularCladding.reduce((a,b) => {
        a['measure'] = a['measure'] + +b['sum_linear_ft'];
        a['what_should_be_paid'] = a['what_should_be_paid'] + +b['what_should_be_paid'];
        a['price'] = a['price'] + +b['adjusted_total_cost'];
        return a
      }, {
        pricing_summary: 'fabricated_regular_cladding',
        measure: 0, 
        what_should_be_paid: 0, 
        price: 0,
        elec_proceeds_for_business: 0, 
        elec_proceeds_for_mitrex: 0, 
        system_size: 0,
        unit: 'LFT',
        icon: irregularCladdingIcon
      }) : null
    },
    irregularSolar({ summaryObject, irregularSolarIcon }) {
      let irregularSolar = summaryObject.irregular_price_by_material.filter(
        d => d.product_brand == 'Mitrex'
      )
      
      return irregularSolar.length > 0 ? irregularSolar.reduce((a,b) => {
        a['measure'] = a['measure'] + +b['sum_linear_ft'];
        a['what_should_be_paid'] = a['what_should_be_paid'] + +b['what_should_be_paid'];
        a['price'] = a['price'] + +b['adjusted_total_cost'];
        return a
      }, {
        pricing_summary: 'fabricated_solar_cladding',
        measure: 0, 
        what_should_be_paid: 0, 
        price: 0,
        elec_proceeds_for_business: 0, 
        elec_proceeds_for_mitrex: 0, 
        system_size: 0,
        unit: 'LFT',
        icon: irregularSolarIcon
      }) : null
    },
    processedSummary({ summaryObject, railingType, irregularCladding, irregularSolar }) {
      // Make a deep copy of the summary
      let summaryCopy = [...summaryObject.summary.map(
        d => Object.assign({}, d))
      ]
      let filteredCopy = []

      /////////////////////////////////////
      // Process walls
      /////////////////////////////////////
      let walls = summaryCopy.filter(
        d => d.pricing_summary.includes('solar_wall')
      )

      if (walls.length > 1) {
        // if there is solar wall active and inactive, combine the two rows
        let solarWall = walls.reduce((a, b) => {
          Object.keys(a).forEach(key => {
            if (key != 'pricing_summary') {
              a[key] = a[key] + +b[key]
            }
          })
          return a
        }, { 
          pricing_summary: 'solar_cladding',
          elec_proceeds_for_business: 0, 
          elec_proceeds_for_mitrex: 0, 
          measure: 0, 
          price: 0, 
          system_size: 0,
          what_should_be_paid: 0
        });

        solarWall['unit'] = 'SQFT';
        solarWall.icon = this.solarCladdingIcon;

        filteredCopy.push(solarWall);
      } else if (walls.length == 1) {
        walls[0]['unit'] = 'SQFT';
        walls[0]['icon'] = this.solarCladdingIcon;
        filteredCopy.push(walls[0])
      }

      if (irregularSolar) {
        filteredCopy.push(irregularSolar);
      }

      let cladding = summaryCopy.filter(
        d => d.pricing_summary == 'cladding'
      )[0];
      if (cladding) {
        cladding['pricing_summary'] = 'regular_cladding'
        cladding['unit'] = 'SQFT';
        cladding['icon'] = this.claddingIcon;
        filteredCopy.push(cladding);
      }

      if (irregularCladding) {
        filteredCopy.push(irregularCladding);
      }

      /////////////////////////////////////
      // Process railing
      /////////////////////////////////////
      var railingLinearFt;
      Object.keys(summaryObject).forEach(key => {
        if (key.replaceAll('_', ' ').includes(railingType)) {
          railingLinearFt = summaryObject[key].map(
            d => d.sum_linear_ft
          ).reduce((a, b) => a + +b, 0);
        }
      })

      // Add in the correct railing type
      summaryCopy.forEach(row => {
        if (
          row.pricing_summary.replaceAll('_', ' ').includes(railingType)
        ) {
          // Replace the measure for railing with linear ft
          row.measure = railingLinearFt;
          row.unit = 'LFT'
          row.icon = this.solarRailingIcon;
          filteredCopy.push(row);
        }
      })
      
      // Add icon to battery
      let battery = summaryCopy.filter(
        d => d.pricing_summary.includes('batteries')
      )[0];

      battery.icon = this.batteryIcon;

      return filteredCopy
    }
  },
  methods: {
    processRowLabel(label) {
      let formatted = label.replaceAll("_", " ");
      return formatted.includes('railing') ? 
        '<span class="solar">Sola</span>Rail' : formatted;
    },
    getTotal(field, subtract) {
      let tot = this.summaryObject.summary.map(
        d => d[field]
      ).reduce((a, b) => a + +b, 0);

      if (!subtract) {
        return tot;
      } else {
        let diff = this.summaryObject.summary.map(
          d => d[subtract]
        ).reduce((a, b) => a + +b, 0);

        return -(tot - diff);
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/flexbox.scss';
@import '@/styles/table.scss';

$overflow-margin: -35px;

.table--wrapper {
  position: relative;
  display: block !important;

  &.overflow {
    left: $overflow-margin;
  }
}

.table {

  tbody, tr, td {
    page-break-inside: avoid !important;
    page-break-before: avoid !important;
    page-break-after: avoid !important;
    break-inside: avoid !important;
    break-before: avoid !important;
    break-after: avoid !important;
  }

  &.overflow {
    width: calc(
      var(--pagedjs-width) - 
      var(--pagedjs-margin-right) - 
      var(--pagedjs-margin-left) + 70px
    );
  }

  .price {
    &--summary{
      color: #0E4E74;
    }

    &--area {
      color: #0E4E74;
      background: #E6ECF2;
    }

    &--value {
      color: #0E4E74;
    }

    &--quote {
      color: #fff;
      background: #0E4E74;
    }

    &--savings {
      color: #fff;
      background: #F16635;
    }

    &--system-size {
      color: #0E4E74;
      background: #fff;
    }

    &--energy-revenue {
      color: #0E4E74 !important;
      background: #E6ECF2;
    }
  }

  tr.top-spacer {
    border-top: 7px solid #fff !important;
  }

  .pricing-summary-icon {
    width: 30px;
    height: 30px;
    margin-right: 0.25em;
    margin-left: 0px;
    margin-top: 0px;
    margin-bottom: 0px;
  }

}

.capitalize {
  text-transform: capitalize;
}

.uppercase {
  text-transform: uppercase;
}
</style>